import { AppSettings } from "appSettings/appSettings.dev";
import {
  Places,
  Answers,
  AnswerResponse,
  SurveyToken,
  SurveyContent,
  SurveySection,
  PersonSurveySend,
  IdentificationType,
  SurveyUserFormModel,
} from "../types";
import { BaseService } from "./BaseService";

class SurveyService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async sendeMailSurvey(personSurvey: PersonSurveySend): Promise<string> {
    const response = await this.baseService.post<PersonSurveySend, string>("/Survey/SendeMailSurvey", personSurvey);
    return response;
  }

  async sendSMSSurvey(personSurvey: PersonSurveySend): Promise<string> {
    const response = await this.baseService.post<PersonSurveySend, string>("/SMSHablame/Send", personSurvey);
    return response;
  }

  async getSurveySection(sectionId: number): Promise<SurveySection> {
    const response = await this.baseService.get<SurveySection>(`/Survey/GetSurveySection?sectionId=${sectionId}`);
    return response.data;
  }

  async authTokenId(surveyTokenId: string): Promise<SurveyToken> {
    const response = await this.baseService.get<SurveyToken>(`/Survey/AuthTokenId?surveyTokenId=${surveyTokenId}`);
    return response.data;
  }

  async getSurveyTokenId(identificationNumber: string): Promise<SurveyToken> {
    const response = await this.baseService.get<SurveyToken>(
      `/Survey/GetSurveyTokenId?identificationNumber=${identificationNumber}`
    );
    return response.data;
  }

  async getSurveyContent(tokenId: string): Promise<SurveyContent[]> {
    const response = await this.baseService.get<SurveyContent[]>(`/Survey/GetContent?TokenId=${tokenId}`);
    return response.data;
  }

  async getAnswers(personId: string, surveyTokenId: string): Promise<Answers[]> {
    const response = await this.baseService.get<Answers[]>(
      `/Survey/GetAnswers?personId=${personId}&token=${surveyTokenId}`
    );
    return response.data;
  }

  async getDataTrigger(triggerId: string, searchId: string): Promise<Places[]> {
    const response = await this.baseService.get<Places[]>(
      `/Survey/GetDataTrigger?triggerId=${triggerId}&searchId=${searchId}`
    );
    return response.data;
  }

  async getIdentificationTypes(): Promise<IdentificationType[]> {
    const response = await this.baseService.get<IdentificationType[]>("/Survey/GetIdentifications");
    return response.data;
  }

  async savePerson(person: SurveyUserFormModel): Promise<string> {
    const response = await this.baseService.post<SurveyUserFormModel, string>("/Survey/SavePerson", person);
    return response;
  }

  async saveSurveyPerson({ person, sectionId }: AnswerResponse) {
    const response = await this.baseService.post<Answers[]>(
      `/Survey/SaveSurveyPerson?requestedSection=${sectionId}`,
      person
    );
    return response.data;
  }
}

export const surveyService = new SurveyService();
